import _ from 'lodash';
import QueryString from 'query-string';
import { useEffect, useState } from 'react';

const extractNameFromColumn = ({ dataPoint }) => dataPoint;

const useFilteredColumns = ({
  columns,
  defaultColumns = columns.map(extractNameFromColumn),
  history,
  location
}) => {
  const [filteredColumns, setFilteredColumns] = useState(defaultColumns);
  const mapColumnOrder = (array, order, key) => {
    array.sort((a, b) => {
      const A = a[key];
      const B = b[key];
      return order.indexOf(A) >= order.indexOf(B) ? 1 : -1;
    });
    return array;
  };

  const filterColumns = (columns, selectedColumns) => {
    const filteredColomns = columns.filter(({ dataPoint }) =>
      selectedColumns.includes(dataPoint)
    );
    return filteredColomns.length ? filteredColomns : columns;
  };

  const initFilteredColumns = () => {
    const search = QueryString.parse(location.search, {
      ignoreQueryPrefix: true
    });

    const selectedColumns = search.columns
      ? search.columns.split(',')
      : defaultColumns;

    const filteredColomns = filterColumns(columns, selectedColumns);

    setFilteredColumns(
      mapColumnOrder(filteredColomns, selectedColumns, 'dataPoint')
    );
  };

  useEffect(() => {
    initFilteredColumns();
  }, [columns]);

  useEffect(() => {
    return () => {
      const search = QueryString.parse(location.search, {
        ignoreQueryPrefix: true
      });

      if (location.search.includes('columns=')) {
        history.replace({
          search: `?${QueryString.stringify({
            ..._.omit(search, ['columns'])
          })}`
        });
      }
    };
  }, [location.search]);

  return filteredColumns;
};

export default useFilteredColumns;
